import React, { ChangeEvent, Component } from 'react';
import FormicaLabel from '../../custom/FormicaLabel';
import LanguageUtil from '../../../util/LanguageUtil';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import RoleHelper from '../../../RoleHelper';
import { TransactionJsonModel, TransactionVariableJsonModel } from '../../../domain/stream/transaction/TransactionDomains';
import { RootState } from '../../../redux/store';
import { TrackerState } from '../../../redux/reducers/TrackerReducer';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { changeTracker, changeTrackerDirty, changeTrackerIsUpdate, clearTracker } from '../../../redux/actions/TrackerActions';
import { clearPage } from '../../../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import FormicaInput from '../../custom/FormicaInput';
import { EventTrackerPlatform } from '../../../domain/tracker/Tracker';
import EmptyComponent from '../../custom/empty-components/EmptyComponent';
import ComponentName from '../../../constant/ComponentName';
import { ColumnProps } from 'primereact/column';
import CustomTable from '../../custom/CustomTable';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import CustomInput from '../../custom/CustomInput';

class TrackerMappingComponent extends Component<Props> {
  public render() {
    const {
      tracker: { tracker },
      transactions,
    } = this.props;
    const selectedTransaction = this.getSelectedTransaction();
    return (
      <div className={'grid grid-cols-5 w-full h-full'}>
        <div className={'col-span-1 flex flex-col border-r border-f-black-5 px-5 py-5 gap-y-4'}>
          <div className={'flex flex-col'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.channel', defaultMessage: 'Channel' })} />
            <FormicaSearchSelectBox
              options={this.getTransactionOptions()}
              onChange={(e: FormicaSelectBoxItem) => {
                this.onChangeTransaction(e);
              }}
              value={tracker.event.name}
              rounded={true}
              disabled={!RoleHelper.canEdit('Tracker')}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.channel', defaultMessage: 'Channel' })}
              label={LanguageUtil.get({ id: 'common.label.channel', defaultMessage: 'Channel' })}
            />
          </div>
          <div className={'flex flex-col'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.key', defaultMessage: 'Key' })} />
            <FormicaInput
              disabled={!RoleHelper.canEdit('Tracker')}
              value={tracker.event.keyMapping}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.key', defaultMessage: 'Key' })}
              onChange={(e) => this.onChangeKey(e)}
            />
          </div>
          <div className={'flex flex-col'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.platform', defaultMessage: 'Platform' })} />
            <FormicaSearchSelectBox
              options={this.getPlatformOptions()}
              onChange={(e: FormicaSelectBoxItem) => {
                this.onChangePlatform(e);
              }}
              rounded={true}
              value={tracker.platform}
              disabled={!RoleHelper.canEdit('Tracker')}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.platform', defaultMessage: 'Platform' })}
              label={'Platform'}
            />
          </div>
        </div>
        <div className={'col-span-4 flex flex-col w-full h-full px-5 py-5 gap-y-2 overflow-y-scroll max-h-[calc(100vh-17.5rem)]'}>
          <div className={'flex flex-col w-full h-full space-y-2 '}>
            {transactions == undefined || transactions.length == 0 ? (
              <div className='items-center  flex justify-center w-full h-full gap-x-4 px-1'>
                <EmptyComponent createDisabled={true} type={ComponentName.TRACKER} />
              </div>
            ) : (
              <CustomTable selectionMode={'single'} dataKey='name' columns={this.getColumns()} value={selectedTransaction?.variables ?? []} />
            )}
          </div>
        </div>
      </div>
    );
  }

  private getSelectedTransaction = (): TransactionJsonModel | undefined => {
    const {
      tracker: { tracker },
      transactions,
    } = this.props;
    const channelName = tracker.event?.name;
    if (channelName == undefined || channelName.trim().length === 0) {
      return undefined;
    }
    return transactions.find((transaction) => transaction.name === channelName);
  };

  private onChangeTransaction = (e: FormicaSelectBoxItem) => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    tracker.event.name = e.value.name;
    tracker.event.variableMappings = {};
    changeTracker(tracker);
  };

  private onChangeKey = (e: any) => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    tracker.event.keyMapping = e.target.value;
    changeTracker(tracker);
  };

  private onChangePlatform = (e: FormicaSelectBoxItem) => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    tracker.platform = e.value;
    changeTracker(tracker);
  };

  private onVariableChange = (e: ChangeEvent<HTMLInputElement>, key: string) => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    tracker.event.variableMappings[key] = e.target.value;
    changeTracker(tracker);
  };

  private getTransactionOptions(): FormicaSelectBoxItem[] {
    const { transactions } = this.props;
    return transactions.map((transaction) => {
      return {
        label: transaction.name,
        value: transaction,
      };
    });
  }

  private getPlatformOptions(): FormicaSelectBoxItem[] {
    return [
      {
        label: EventTrackerPlatform.MOBILE,
        value: EventTrackerPlatform.MOBILE,
      },
      {
        label: EventTrackerPlatform.WEB,
        value: EventTrackerPlatform.WEB,
      },
    ];
  }

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'variables',
        header: LanguageUtil.get({ id: 'pages.tracker.table.name', defaultMessage: 'Name' }),
        alignHeader: 'left',
        className: 'w-1/2',
        sortable: false,
        body: (rowData: TransactionVariableJsonModel) => {
          return (
            <div className={'flex w-full items-center'}>
              <CustomTableContentWrapper text={rowData.name} />
            </div>
          );
        },
      },
      {
        field: 'value',
        header: LanguageUtil.get({ id: 'pages.tracker.editor.mapping.table.value', defaultMessage: 'Value' }),
        className: 'w-1/2',
        sortable: false,
        body: (rowData: TransactionVariableJsonModel) => {
          const {
            tracker: { tracker },
          } = this.props;
          return (
            <div className={'flex w-full items-center'}>
              <FormicaInput
                placeholder={LanguageUtil.get({ id: 'pages.tracker.editor.mapping.table.placeholder.value', defaultMessage: 'Enter value' })}
                inputType={'ghost'}
                type={'text'}
                onChange={(e: ChangeEvent<HTMLInputElement>) => this.onVariableChange(e, rowData.name)}
                value={tracker.event?.variableMappings?.[rowData.name] ?? ''}
              />
            </div>
          );
        },
      },
    ];
  };
}

interface Props extends FormicaProps, ReduxProps {
  transactions: TransactionJsonModel[];
}

const mapStateToProps = (state: RootState) => ({
  tracker: state.tracker as TrackerState,
  lastCategory: state.page.lastCategory,
  isUpdate: state.tracker.isUpdate,
});

const mapDispatchToProps = {
  enterComponent,
  leaveComponent,
  changeTracker,
  changeTrackerIsUpdate,
  clearTracker,
  clearPage,
  changeTrackerDirty,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(TrackerMappingComponent));
